import Icon from '@/components/ui/AppIcon';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: 'ShieldCheckIcon',
      title: 'Zero Preservatives',
      description: 'Only natural ingredients, no artificial chemicals or additives',
      color: 'text-success',
      bgColor: 'bg-success/10',
    },
    {
      icon: 'BeakerIcon',
      title: 'Traditional Methods',
      description: 'Time-honored recipes passed down through generations',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
    },
    {
      icon: 'SparklesIcon',
      title: 'Farm-Fresh Ingredients',
      description: 'Sourced directly from organic farms we trust',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
    },
    {
      icon: 'HeartIcon',
      title: 'Authentic Taste',
      description: 'Exactly like your grandmother used to make',
      color: 'text-error',
      bgColor: 'bg-error/10',
    },
    {
      icon: 'CheckBadgeIcon',
      title: 'Health Benefits',
      description: 'Packed with natural nutrients and probiotics',
      color: 'text-success',
      bgColor: 'bg-success/10',
    },
    {
      icon: 'EyeIcon',
      title: 'Complete Transparency',
      description: 'Know exactly what goes into every product',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
    },
  ];

  return (
    <section id="why-choose-us" className="bg-background py-16 lg:py-24">
      <div className="mx-auto max-w-[1200px] px-6">
        <div className="mb-12 text-center">
          <h2 className="font-heading mb-4 text-3xl font-bold text-foreground lg:text-4xl">
            Why Choose <span className="text-primary">Granny'z Farm Fresh</span>?
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
            Experience the perfect blend of tradition, health, and authentic taste
          </p>
        </div>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="group rounded-2xl bg-card p-6 shadow-cta transition-all duration-250 ease-out hover:shadow-lg"
            >
              <div
                className={`mb-4 inline-flex rounded-xl ${benefit.bgColor} p-4 transition-transform duration-250 ease-out group-hover:scale-110`}
              >
                <Icon
                  name={benefit.icon as any}
                  size={32}
                  className={benefit.color}
                />
              </div>
              <h3 className="font-heading mb-2 text-xl font-bold text-foreground">
                {benefit.title}
              </h3>
              <p className="text-muted-foreground">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-2xl bg-primary/5 p-8 text-center">
          <Icon
            name="SparklesIcon"
            size={48}
            className="mx-auto mb-4 text-primary"
          />
          <h3 className="font-heading mb-2 text-2xl font-bold text-foreground">
            Our Promise to You
          </h3>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
            Every jar is made with the same love and care that your grandmother
            would put into her cooking. We never compromise on quality, authenticity,
            or tradition.
          </p>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;